import { render, staticRenderFns } from "./UsersListItem.vue?vue&type=template&id=035605c6&"
import script from "./UsersListItem.vue?vue&type=script&lang=ts&"
export * from "./UsersListItem.vue?vue&type=script&lang=ts&"
import style0 from "./UsersListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports